import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from '@/components/shared/ErrorBoundary';
import './styles/globals.css';
import './styles/print.css';
import { installGlobalErrorHandlers } from '@/lib/utils/globalErrors';

installGlobalErrorHandlers();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
);
